import ClearFilters from "admin/Filters/ClearFilters";
import RowsPerPage from "admin/Filters/RowsPerPage";
import Search from "admin/Filters/Search";
import OrdersFilter from "admin/Orders/OrdersFilter";
import { OrderFilterProvider } from "admin/Orders/OrdersFilter/OrderFilterContext";

// import useOrdersFilters from "admin/Orders/useOrdersFilters";
import useGetAssignableOrders from "api/OrderResource/useGetAssignableOrders";
import Admin2 from "layouts/Admin2";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { activeCurrencies } from "utils";
import { formData } from "../OrdersFilter/ordersQueryParams";
import useOrdersFilters from "../OrdersFilter/useOrdersFilters";
import useGetCouriers from "api/UserResource/useGetCouriers";
import AssignOrderToCourier from "./AssignOrderToCourier";

const OrdersToAssign = () => {
	const filters = useOrdersFilters();
	const { data: payload, isLoading } = useGetAssignableOrders({
		page: filters?.page,
		rows_per_page: filters?.rowsPerPage,
		search: filters?.search,
		from_date: filters?.fromDate,
		to_date: filters?.toDate,
	});

	const { data: couriersPayload, isLoading: isCouriersLoading } = useGetCouriers();

	const ordersList = payload?.data?.records;
	const totalRecords = payload?.data?.total_records || 0;

	const numberOfActiveFilters = filters?.allSearchParams
		?.filter((param) => !filters?.paginationParams?.includes(param))
		?.filter((param) => filters[param] !== "")?.length;

	console.log({ ordersList });

	const customerTemplate = (row) => (
		<div className="flex flex-col">
			<span className="font-bold">
				{row?.user?.first_name} {row?.user?.last_name}
			</span>
			<span>{row?.user?.email}</span>
		</div>
	);

	const orderIdTemplate = (row) => (
		<div className="flex flex-col">
			<span>{row?.order_number}</span>
		</div>
	);

	const referenceTemplate = (row) => (
		<div className="flex flex-col">
			<span>{row?.ecocash_reference ? row?.ecocash_reference : row?.reference}</span>
		</div>
	);

	const paymentMethodTemplate = (row) => (
		<div className="flex flex-col">
			<span>{row?.payment_method}</span>
		</div>
	);

	const amountTemplate = (row) => {
		let amountLabel = "-";
		const currency =
			row?.currency === activeCurrencies.USD.code
				? activeCurrencies.USD.label
				: activeCurrencies.ZWL.label;

		amountLabel = `${currency} $${Number(row?.total_amount)?.toFixed(2)}`;

		return <span className="text-base font-bold">{amountLabel}</span>;
	};

	const dateCreatedTemplate = (row) => (
		<div className="flex flex-col">
			<span>{row?.created_at}</span>
		</div>
	);

	const assignOrderToCourierTemplate = (row) => (
		<AssignOrderToCourier
			orderId={row?.id}
			orderNumber={row?.order_number}
			couriers={couriersPayload?.data?.records || []}
		/>
	);

	const statusTemplate = (row) => (
		<div className="flex flex-col">
			<span className="text-akgreenest ">{row?.status}</span>
		</div>
	);

	return (
		<Admin2>
			<OrderFilterProvider>
				<div className="flex flex-col w-full mt-4">
					<DataTable
						loading={isLoading || isCouriersLoading}
						value={ordersList}
						dataKey="id"
						header={
							<div className="space-y-4 font-sans text-sm ">
								<h3 className="font-bold flex items-center justify-between gap-3 rounded-full max-w-max">
									<span>Purchase orders for assigning</span>
									<span className="block bg-gray-400 rounded-full text-white py-1 max-w-max px-2 text-center">
										{totalRecords}
									</span>
								</h3>

								<div className="flex items-center gap-2 justify-between ">
									<RowsPerPage filters={filters} formData={formData} />

									<Search
										filters={filters}
										formData={formData}
										placeholder="Search order ID, number, reference etc..."
									/>

									<ClearFilters filters={filters} numberOfActiveFilters={numberOfActiveFilters} />

									<OrdersFilter numberOfActiveFilters={numberOfActiveFilters} />
								</div>
							</div>
						}
						tableClassName="font-sans text-sm w-full"
						autoLayout
					>
						<Column header="Customer" body={customerTemplate} />
						<Column header="Order Number" body={orderIdTemplate} />
						<Column header="Reference" body={referenceTemplate} />
						<Column header="Payment method" body={paymentMethodTemplate} />

						<Column header="Date created" body={dateCreatedTemplate} />
						<Column header="Status" body={statusTemplate} />
						<Column header="Amount" body={amountTemplate} />
						<Column header="Actions" body={assignOrderToCourierTemplate} />
					</DataTable>
				</div>
			</OrderFilterProvider>
		</Admin2>
	);
};

export default OrdersToAssign;
